var _style, _polygon, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecents(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 18 18",
    style: {
      enableBackground: "new 0 0 18 18"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#333333;}\n")), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    id: "Hands_1_",
    className: "st0",
    points: "13.8,10.7 10,8.4 10,3 9,3 9,9 13.3,11.5 "
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Arrow",
    className: "st0",
    d: "M9.5,0C5.7,0,2.4,2.5,1.4,6H0.2C0,6-0.1,6.2,0,6.3l1.8,2.6C1.9,9,2.1,9,2.2,8.9l1.8-2.6  C4,6.2,3.9,6,3.8,6H2.4c1-2.9,3.8-5,7.1-5C13.6,1,17,4.4,17,8.5S13.6,16,9.5,16c-3.1,0-5.8-1.9-6.9-4.6l-0.9,0.4C3,14.9,6,17,9.5,17  c4.7,0,8.5-3.8,8.5-8.5S14.2,0,9.5,0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecents);
export default __webpack_public_path__ + "static/media/recents.0a39476d0f6a7668a7541a2a87334477.svg";
export { ForwardRef as ReactComponent };